import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';

import { AppLayout } from './components/layout/AppLayout';
import { AuthGate } from './components/layout/AuthGate';
import { RouteFallback } from './components/layout/RouteFallback';
import { ScopeGuard } from './components/layout/ScopeGuard';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Journal = lazy(() => import('./pages/Journal'));
const Expenses = lazy(() => import('./pages/Expenses'));
const Settings = lazy(() => import('./pages/Settings'));
const Login = lazy(() => import('./pages/Login'));
const AuthCallback = lazy(() => import('./pages/AuthCallback'));
const NotFound = lazy(() => import('./pages/NotFound'));

const wrap = (el: React.ReactElement) => <Suspense fallback={<RouteFallback />}>{el}</Suspense>;

export const router = createBrowserRouter([
  { path: '/login', element: wrap(<Login />) },
  { path: '/auth/callback', element: wrap(<AuthCallback />) },
  {
    element: (
      <AuthGate>
        <AppLayout />
      </AuthGate>
    ),
    children: [
      { path: '/', element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: wrap(<Dashboard />) },
      {
        path: '/journal',
        element: <ScopeGuard scope="journal">{wrap(<Journal />)}</ScopeGuard>,
      },
      {
        path: '/expenses',
        element: <ScopeGuard scope="expense">{wrap(<Expenses />)}</ScopeGuard>,
      },
      { path: '/settings', element: wrap(<Settings />) },
    ],
  },
  { path: '*', element: wrap(<NotFound />) },
]);
